import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  public currentVersion: string = environment.webAppVersion;
  public showPrompt: boolean = false;


  constructor(
    private authenticationService: AuthenticationService,
  ) { }

  //environment setup
  checkForUpdates(): void {
    if(this.currentVersion){
      this.authenticationService.getNewVersion().subscribe(res => {
        if(res && res.response == '200'){
          if(res.data && this.currentVersion !== res.data){
            this.promptUserForUpdate();
          }
        }
      })  
    }
  }


  //cookie setup
  // getVersion() {
  //   let isCurrent = this.cookieService.check('currentVersion');
  //   if (!isCurrent) {
  //     let expiryDate = new Date();
  //     expiryDate.setDate(expiryDate.getDate() + 100);
  //     this.cookieService.set('currentVersion', "", {
  //       expires: expiryDate,
  //       path: '/'
  //     });
  //   }
  // }

  // checkForUpdates(): void {
  //   this.getVersion();
  //   this.authenticationService.getNewVersion().subscribe(res => {
  //     if (res && res.response == '200') {
  //       this.currentVersion = this.cookieService.get('currentVersion');
  //       let expiryDate = new Date();
  //       expiryDate.setDate(expiryDate.getDate() + 100);
  //       // if(this.cookieService.check('newVersion')){
  //       //   this.cookieService.delete('newVersion')
  //       // }
  //       this.cookieService.set('newVersion', res.data, {
  //         expires: expiryDate,
  //         path: '/'
  //       });
  //       let newVersion = this.cookieService.get('newVersion');
  //       if (newVersion && this.currentVersion !== newVersion) {
  //         this.cookieService.set('currentVersion', newVersion, {
  //           expires: expiryDate,
  //           path: '/'
  //         });
  //         this.promptUserForUpdate();
  //       }
  //     }
  //   });
  // }

  // checkCookies(){
  //   let currentVersion = this.cookieService.get('currentVersion');
  //   let newVersion = this.cookieService.get('newVersion');
  //   if(currentVersion != newVersion){
  //     this.promptUserForUpdate();
  //   }
  // }

  getShowPromt() {
    return this.showPrompt;
  }

  promptUserForUpdate(): void {
    this.showPrompt = true;
  }

  hidePrompt(): void {
    this.showPrompt = false;
  }
}
